import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './VistaProduct.d'

const ROOT_URL = '/entity/vista-products'

export const VistaProductRepository = {
  FindByVistaId: async (params: Repo.VistaProduct.FidByVistaId.Params) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.VistaProduct.FidByVistaId.Response>(url)
  },

  Create: async (params: Repo.VistaProduct.Create.Params) => {
    const url = ROOT_URL
    return await WitaConnector.post<Repo.VistaProduct.Create.Response>(
      url,
      params,
    )
  },

  Edit: async ({ id, ...params }: Repo.VistaProduct.Edit.Params) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<Repo.VistaProduct.Edit.Response>(url, params)
  },

  Delete: async ({ id }: Repo.VistaProduct.Delete.Params) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.delete<Repo.VistaProduct.Delete.Response>(url)
  },
}
